var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import { filter } from 'rxjs/operators';
import { ItemList } from '../item-list';
import { Container } from '../services/di';
import { compilePattern } from '../util';
var DynamicSelect = /** @class */ (function (_super) {
    __extends(DynamicSelect, _super);
    function DynamicSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null,
            invalid: false,
            help: null,
            open: false,
            disabled: false,
            loading: false,
            items: []
        };
        return _this;
    }
    DynamicSelect.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this; }))
            .subscribe(function (e) {
            _this.refreshDisabledState();
        });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            invalid: false,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            invalid: true,
            help: Object.keys(error.constraints)
                .map(function (key) { return React.createElement(React.Fragment, null,
                React.createElement("span", null, error.constraints[key]),
                React.createElement("br", null)); })
        }); });
        this.refreshDisabledState();
        this._setupItemListHandler();
    };
    DynamicSelect.prototype.setValue = function (item) {
        this.setState({
            value: item.key
        });
        this.props.dataState.set(this.props.control.path, item.key, {
            sender: this
        });
    };
    DynamicSelect.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicSelect.prototype.getKey = function (item) {
        return item.key;
    };
    DynamicSelect.prototype.onSearch = function (value) {
        if (this.itemList) {
            this.itemList.refresh(value);
        }
    };
    DynamicSelect.prototype.refreshDisabledState = function () {
        if (this.props.control.disableWhen) {
            this.setState({
                disabled: this.props.dataState.executeExpression(this.props.control.disableWhen)
            });
        }
        else if (this.props.control.enableWhen) {
            this.setState({
                disabled: this.props.dataState.executeExpression(this.props.control.enableWhen)
            });
        }
    };
    DynamicSelect.prototype.render = function () {
        var _this = this;
        if (this.props.control.items) {
            return React.createElement(Autocomplete, { open: this.state.open, onOpen: function () {
                    _this.setState({ open: true });
                    _this.onSearch(null);
                }, onClose: function () { return _this.setState({ open: false }); }, getOptionSelected: function (option, value) { return option.key === value.key; }, getOptionLabel: function (option) { return option.label; }, loading: this.state.loading, options: this.state.items, onChange: function (event, value) { return _this.setValue(value); }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: _this.props.control.label, variant: "outlined", margin: "dense", error: _this.state.invalid, helperText: _this.state.help, InputLabelProps: {
                        shrink: true
                    }, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                            _this.state.loading ? React.createElement(CircularProgress, { color: "inherit", size: 20 }) : null,
                            params.InputProps.endAdornment)) }) }))); } });
        }
        else if (this.props.control.endpoint) {
            return React.createElement(Autocomplete, { open: this.state.open, disabled: this.state.disabled, onChange: function (event, value) { return _this.setValue(value); }, onOpen: function () {
                    _this.setState({ open: true });
                    _this.onSearch(null);
                }, onClose: function () { return _this.setState({ open: false }); }, getOptionSelected: function (option, value) { return option.key === value.key; }, getOptionLabel: function (option) { return option.label; }, loading: this.state.loading, options: this.state.items, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: _this.props.control.label, variant: "outlined", margin: "dense", error: _this.state.invalid, helperText: _this.state.help, InputLabelProps: {
                        shrink: true
                    }, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                            _this.state.loading ? React.createElement(CircularProgress, { color: "inherit", size: 20 }) : null,
                            params.InputProps.endAdornment)) }) }))); } });
        }
    };
    DynamicSelect.prototype._setupItemListHandler = function () {
        var _this = this;
        if (this.props.control.items) {
            this.setState({
                items: [].concat(this.props.control.items)
            });
        }
        else if (this.props.control.endpoint) {
            this.itemList = new ItemList(function (offset, payload) { return __awaiter(_this, void 0, void 0, function () {
                var url, records;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = compilePattern(this.props.control.endpoint, __assign(__assign(__assign({}, this.props.dataState.record), { $offset: offset, $count: this.props.control.pageCount }), payload));
                            return [4 /*yield*/, Container.http.get(url)];
                        case 1:
                            records = _a.sent();
                            this.setState({
                                items: records.map(function (record) {
                                    if (record.id) {
                                        return {
                                            key: record.id,
                                            label: compilePattern(_this.props.control.itemLabelPattern, record, Container.locale),
                                        };
                                    }
                                    else {
                                        return record;
                                    }
                                })
                            });
                            return [2 /*return*/, records];
                    }
                });
            }); }, {
                count: this.props.control.pageCount
            });
        }
    };
    return DynamicSelect;
}(React.Component));
export default DynamicSelect;
//# sourceMappingURL=Select.js.map